<!--
 * @Author: scg
 * @Date: 2022-01-17 16:18:42
 * @LastEditTime: 2022-01-25 10:58:25
 * @LastEditors: scg
 * @Description:
-->
<template>
<div  class="fff">
  <div class="page_title">Guidance</div>
  <div class="page_bo_li">
    <div class="ShoppingCart_t_l Guidance">
      <img src="@/assets/img/b.png">
      <div>Set Up a Target Device</div>
      <p>This guide will show you how to install Spylix on the device you want to monitor.</p>
        <div>Note:</div>
      <p>1. To set up an Android device, you need to get the target device.</p>
      <p>2. To set up an iOS device, you need to get the iCloud credentials of the target device.</p>
    </div>
  </div>
  <div @click="$router.push({path: system==='iOS'?'/Enter':'/Manufacturer'})" class="loginButton ShoppingCartButton">Start</div>
</div>
<!--  -->
<!--  -->
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: '',
      system: 'iOS'
    }
  },
  mounted () {
    this.system = localStorage.getItem('system')
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fff{width:100%;position:absolute;height:100%;background:#fff;overflow:hidden}
.page_bo_li{margin-bottom:40px}
.Guidance{overflow:hidden;}
.Guidance img{float:left;width:90px;overflow:hidden;margin:40px}
.Guidance div{overflow:hidden;margin:0 0 0;line-height:40px;font-size:16px;color:#000927;font-weight:700}
.Guidance p{font-size:13px;color:grey;margin-top:0}
.ShoppingCartButton{float:left;margin-left:5%;width:280px;height:44px;line-height:44px;font-size:15px}

</style>



// WEBPACK FOOTER //
// src/components/Guidance.vue